import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-head" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "entity-box"
}
const _hoisted_4 = { class: "key" }
const _hoisted_5 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["entity-page", { 'entity-page-show': _ctx.show }]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false))
  }, [
    _createElementVNode("div", {
      class: "entity-base",
      "dark-class": "entity-base-dark",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "back-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
        }, [
          _createVNode(_component_elem_icon, { name: "arrow_right_white" })
        ]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.entity_title), 1)
      ]),
      (_ctx.entity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["item-box", 'item-' + item.type]),
                key: idx
              }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.entity[item.name] ?? '-'), 1)
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}